import axios from "axios";
import Common from '@/common.js'


const state = {
    categories:{},
    subcategories:{}
};
const getters = {
    AllCategories: state => state.categories,
    Subcategories: state => state.subcategories,
};
const actions = {
    async getCategories({commit}){
        var url = Common.getApiCallUrl("Items/ItemController::GetCategory");
        const response = await axios.post(url,{},Common.getRequestHeader());
        //Common.callServerFunction("Items/ItemController::GetCategory",this.api_response,{},commit);
        var data = Common.mapResponse(response.data)
        //alert(data);
        commit("setCategories",data);
   },
   async getSubCategories({commit},categoryId){
    var url = Common.getApiCallUrl("Items/ItemController::GetSubCategory");
    const response = await axios.post(url,{"categoryId":categoryId},Common.getRequestHeader());
    //Common.callServerFunction("Items/ItemController::GetCategory",this.api_response,{},commit);
    var data = Common.mapResponse(response.data)
    //alert(data);
    commit("setSubCategories",data);
}
//   ,api_response:function(response, commit)
//   {
//        var rdata = JSON.parse(response);
//        alert(rdata)
//        commit("setCategories",rdata);
//   }

};
const mutations = {
    setCategories:(state, categories) => (state.categories = JSON.parse(categories)),
    setSubCategories:(state, subcategories) => (state.subcategories = JSON.parse(subcategories))
};

export default{
    state,
    getters,
    actions,
    mutations
};